import React from 'react';

import { ThemedPageTitle } from '@fides/fides-react-components';

export const AwThemedPageTitle = (props) => {
  return <ThemedPageTitle {...props} />;
}
